// Created to help keep logic clean and size of the main Form Save Service down for debugging.
import Immutable        from 'immutable';
import {Maybe}          from 'monet';
import {Nothing}        from 'monet';
import themeService     from 'ThemeService';
import {inverseTypeMap} from 'typeIndex';
import constants        from 'Constants';
import listService      from 'ListService';
import mobileListService from "mobile/MobileListService";
import util             from 'util/Util';
import formulaService   from 'xml/FormulaService';
import settingsUtil     from 'util/SettingsUtil';
import fontService from 'FontService';

const ID_ALL = 'all';


// Translates internal prop names to PF prop names
const cmdPropXateMap = Immutable.Map({ 'left': 'x', 'top': 'y'});

// We filter-EXclude these when emitting commands
const commandPropExclusions = Immutable.Set( [ 'rawId',
    'widgetText', 'factory', 'icon', 'factoryKey', 'default', 'connections', 'name', 'id', 'selectedFieldName',
    'autoSummaryFlag', 'autoSummaryAreaState', 'autoSummaryArea', 'gridData', 'colModel', 'colNames', 'type',
    'undoEvent', 'trackEnabled', 'widget', 'cancelNotifyUser', 'cancelNotifyUserGroup', 'cancelNotifyPosition',
    'cancelNotifyFixedEmail', 'fixedEmailWriteable', 'cancelNotifyEnteredEmail', 'cancelNotifyType', 'Parameters',
    'autosummaryChecked', 'viewTitle', 'specialInstance', 'selectedPageIds', 'specificPageDisabled', 'Property', 'pages', 'selected',
    'selectFieldTitle', 'customMessageDisabled', 'mandatoryMessageType', 'propertyList', 'fromFields', 'toFields', 'fromRows', 'toRows',
    'rowid','0', 'gridData2', 'colModel2', 'colNames2', 'Request', 'ValueOfAField', 'rowid2', 'CustomParameters', 'targetFieldName', 'sectionTitle',
    'selectedInstanceFieldName', 'selectedValueFieldName', 'PropId', 'textOrNumberValue', 'returnValueTarget', 'functionName', 'conditionDisabled',
    'conditionReadOnly','secondCondition', 'conditionSelect', 'undoAction', 'valueOfAField', 'customURL', 'relatedFields', 'relatedPages'
]);

// We filter-include these
const controlPropInclusions = Immutable.Set([
    'backgroundColor', 'obligatoryMessage', 'tabEnabled', 'accessSilent', 'textColor', 'align', 'transparency',
    'isHtml', 'width', 'text', 'encrypt', 'top', 'accessDesc', 'left', 'zOrder', 'padding', 'rtl', 'toolTip',
    'height', 'assetId', 'stretch', 'maintainAspectRatio', 'closeOption', 'confirmationMessage', 'showConfirmation',
    'submitAsChildIfNoParent', 'buttonStyle', 'page', 'pageType', 'borderColor', 'format', 'selected', 'horizontalScroll',
    'maxChars', 'verticalScroll', 'decimalLength', 'showLeadingZero', 'paddingEnabled', 'paddingCharacter', 'paddingAlignment', 'paddingAmmount',
    'max', 'min', 'decimalSeparator', 'allowNegative', 'thousandsSeparator', 'symbol', 'showNow', 'showEmpty', 'maxYear',
    'specific', 'minYear', 'is24HourClock', 'hasSeconds', 'selectedIndex', 'multiSelection', 'lineColor', 'loop', 'autoStart',
    'startTime','endTime','time','direction','interval', 'autoPlay', 'mute', 'volume', 'target', 'showLabel', 'value', 'autoValue',
    'barColor', 'label', 'section', 'pageIds', 'appendixDpi', 'appendixUnit', 'appendixWidth', 'appendixHeight', 'appendixSizePreset',
    'length', 'mask', 'stepSize', 'minChars', 'signatureColor', 'signatureThickness', 'buttonLabelSave', 'buttonLabelClear',
    'buttonSaveShow', 'buttonBackgroundColor', 'buttonBackgroundGradientColor', 'imageBackgroundColor', 'buttonPositionAbove', 'buttonTextColor',
    'buttonLabelDetach', 'buttonLabelAttach', 'buttonPositionLeft', 'filetypes', 'maxSize', 'customFiltypes', 'tickColor', 'maxText', 'minText',
    'maxValue', 'minValue', 'value', 'snapInterval', 'tickInterval', 'sliderColor', 'formName', 'formId', 'formGUID', 'linkId',
    'newWindow', 'isReport', 'parentChild', 'childInstanceGUID', 'showError', 'cornerRadius', 'reportId', 'reportName', 'reportGUID',
    'normalRowBgColor', 'alternateRowBgColor', 'headerHeight', 'headerTextColor', 'headerBgColor', 'headerBgColorGradient', 'showFooter', 'showHeader',
    'allowColumnResize', 'columnsWidths', 'rowHeight', 'buttons', 'maxRows', 'pieLabelsPositions', 'dataSourceId', 'additiveDynamicFilter',
    'respectDynamicFilter', 'setDynamicFilter', 'ignoreNull', 'axisColor', 'horizontalAxis', 'barChartType', 'verticalAxis','lineColor','lineChartType',
    'needleColor', 'dialRightColor', 'dialLeftColor','formatOption','operator','type', 'dataType', 'text1','text2','variableRowHeight','linksNewWindow','showDsInfo',
    'sortOrder', 'showNavButtons', 'allowExport', 'border', 'buttonLabelRemove', 'buttonLabelAcquire', 'hasTitle', 'titleText', 'titleColor', 'titleHeight',
    'titleAlign', 'titleBackgroundColor','transparentBackground',
    'customFormat', 'text','align','backgroundImageAssetId','backgroundImageStyle','footerfun','margins', 'naturalWidth', 'naturalHeight', 'autocomplete', 'isWebFont',
    'printFileName', 'printQuality', 'autocompleteEnabled', 'autocompleteActivateOn', 'autocompleteSource', 'listId', 'isNew'
]);

const notificationsPropInclusions = Immutable.Set([
    'emailAuthUsername', 'personUserId', 'personUserGroupId', 'personUserGroupName', 'emailDisplayName', 'activationRecurisveEmailNumber', 'personPositionId', 
    'existingInstanceAttachmentSelected', 'messageSubject', 'printAttachmentSelected', 'insertCheck', 'activationPeriodUnitField', 'emailReplyToDisplayName', 
    'title', 'activationDateExpression', 'attentionLevel', 'cancelType', 'personPositionName', 'emailAuthPassword', 'cancelAllOthers', 'activationPeriodAmountFieldId', 
    'personUserName', 'activationRecurisveEmailFrequency', 'personType', 'roleId', 'activationPeriodAmountLiteral', 'instanceCheck', 'printCheck', 'emailServerId', 
    'cancelScope', 'printAttachment', 'activationType', 'hasHtmlForm', 'messageSendEmail', 'activationDate', 'emailEmailAddress', 'activationDateField', 
    'insertAttachmentSelected', 'personEmailFieldId', 'personEmailLiteral', 'activationPeriodUnitLiteral', 'cancelCondition', 'insertAttachment', 
    'existingInstanceAttachment', 'messageHtml', 'emailReplyToEmailAddress', 'messageText'
]);


class SaveHelperService {

    processFont( model, fontPropName) {
        let font = model.get(fontPropName[0]);
        let fontFromTheme, textWeightFromTheme, textStyleFromTheme;
        let fontArr = [];

        // If has font and size
        if (model.get(fontPropName[0]) && model.get(fontPropName[1])) {
            if(font === "__custom__"){ //Empty custom font, use first valid font
                const fonts = fontService.getFonts();
                model.set(fontPropName[0], fonts[0].name, {silent:true});
            }
 
            // If font is from theme, return as it is
            if (model.get(fontPropName[0]).startsWith && model.get(fontPropName[0]).startsWith('~') &&
                model.get(fontPropName[1]).startsWith && model.get(fontPropName[1]).startsWith('~')) {
                fontFromTheme = true;
            }
            fontArr.push(themeService.resolveThemeFont('fontFamily', model.get(fontPropName[0])).trim());
            fontArr.push(themeService.resolveThemeFont('fontSize', model.get(fontPropName[1])).toString().trim());
        }

        // Resolve text weight (bold or normal)
        if (model.get(fontPropName[2])) {
            if (model.get(fontPropName[2]).startsWith && model.get(fontPropName[2]).startsWith('~')) {
                textWeightFromTheme = true;
            }
            fontArr.push(themeService.resolveThemeFont('textWeight', model.get(fontPropName[2])).replace('!important', '').trim());
        }

        // Resolve text style (italic or normal)        
        if (model.get(fontPropName[3])) {
            if ( model.get(fontPropName[3]).startsWith && model.get(fontPropName[3]).startsWith('~')) {
                textStyleFromTheme = true;
            }
            fontArr.push(themeService.resolveThemeFont('textStyle', model.get(fontPropName[3])).replace('!important', '').trim());
        }

        // Return theme if all are from theme  
        if (font) {
            if (fontFromTheme && textWeightFromTheme && textStyleFromTheme) {
                font = model.get(fontPropName[0]);
            } else {
                font = fontArr.join(',');
            }
        }

        return font ? font.trim() : font;
    }

    processWebFont(fontFamily){
        const webFont = fontService.webFonts.find(font => font.name === fontFamily);
        return webFont ? webFont.name + "," + webFont.file : "";
    }

    setColorValue( props, targetName, value) {
        if (value) {
            props[targetName] = value.replace('#','');
        }
    }

    //=============================================================================
    // obj: a behavior instance
    // control: could be a table column view, a page view, or a basic control view
    //=============================================================================
    behaviorsSaveHelper(obj, control) {
        const behaviorKey = 'behaviorKey';

        function xlateProp(propName) {

            const p = propName;
            if (cmdPropXateMap.has(p)) {
                return cmdPropXateMap.get(p);
            }
            return p;
        }
   
        // cons is a list of connectionVO objects
        function emitConnectors(parent, cons, processedConnectors, scriptId) {

            const testParam = (key, parameter) => {
                return parameter.hasOwnProperty(key) &&
                    (parameter[key] !== undefined) && (key !== 'EXPR') &&
                    (key !== 'Expression') &&
                     key !== '$' && !util.isEmpty(parameter[key].trim())
            };

            cons
                .filter((c, k) => c.scriptId === scriptId)
                .forEach((c, k) => {
                        if (!processedConnectors[k]) {
                        //    console.log(`SCRIPT CONNECTORS`, c);

                            const cout = {Connector: {_id: listService.getCleanedId(c.id), _type: "scriptconnector"}};
                            const p = cout.Connector.Properties = {};
                            // const owners = model.get('owners');

                            p._sourceShape = listService.getCleanedId(c.srcCommand.model.get('id'));
                            p._targetShape = listService.getCleanedId(c.destCommand.model.get('id'));

                            p._textBoxWidth = c.model.attributes.textBoxWidth;
                            p._textBoxHeight = 20;

                            // PF-2345 - don't hard-code line type
                            p._lineType = c.model.attributes.lineType;

                            p._text = c.model.attributes.text;

                            // PF-2345 - don't hard-code control points
                            p._ctrlPoint1x = c.model.attributes.ctrlPoint1x;
                            p._ctrlPoint2y = c.model.attributes.ctrlPoint2y;
                            p._ctrlPoint1y = c.model.attributes.ctrlPoint1y;
                            p._ctrlPoint2x = c.model.attributes.ctrlPoint2x;

                            p._autosummary = c.model.get('autosummary');
                            p._sourcePoint = Number(c.srcDot);
                            p._targetPoint = Number(c.destDot);

                            if (c.model.attributes.Parameters) {
                                cout.Connector.Parameters = {};
                                cout.Connector.Parameters.Parameter = [];
                                let Parameter;
                                _.forEach(c.model.attributes.Parameters.Parameter, (parameter) => {
                                    Parameter = {};

                                    Object
                                        .entries(parameter)
                                        .filter((object) => {
                                            return testParam(object[0], parameter);
                                        }).forEach((object) => {
                                            const key = `_${object[0]}`;
                                        Parameter[key] = object[1];
                                    });
                                    
                                    if (parameter.Expression) {
                                        Parameter.Expression = formulaService.convertExpression(parameter.Expression);
                                    }

                                    cout.Connector.Parameters.Parameter.push(Parameter);
                                });
                            }

                            parent.push(cout.Connector);

                           // console.log(`connector object`, cout);
                            processedConnectors[k] = true;
                        }
                    }
                );
        }


        // PF origin is top left of object. Fabric.js origin is center of object.
        // Mutate outgoing (0,0) to top left that is assumed by PF.
        // Arg assumed to be command.properties
        // function originToTopLeft(p) {
        //     const
        //         w = Number(p['_width']),
        //         h = Number(p['_height']),
        //         x = Number(p['_x']),
        //         y = Number(p['_y']);

        //     p['_x'] = x - w / 2;
        //     p['_y'] = y - w / 2;

        //     console.log(`Inbound pos (${x},${y}} - Outbound pos (${p['_x']},${p['_y']})`);
        // }


        let commands, eventId, script, processedConnectors;

        listService.behaviorInstances
            .filter(model => model.get('ownerId') === control.id)
            .forEach((model, scriptId) => {
               // console.log(`### a objectBehaviorsHelper`, obj, control);
               // console.log(`### b bound behavior instance to ${control.id}:`, model, scriptId);               
               eventId = util.prefixLeadingUnderscore(model.get(behaviorKey));
                const parsedItem = typeof model.get('parsedItem') !== 'undefined' ? _.cloneDeep(model.get('parsedItem')) : undefined;
                if (parsedItem && listService.isPartialSave){ //IMPORTANT: If exist then it was not modified
                    if (obj._type === 'workflowconnector') {
                        obj.Script = parsedItem;
                    } else {
                        obj.Events = obj.Events || {};
                        obj.Scripts = obj.Scripts || {Script: []};
                        obj.Events[eventId] = listService.getCleanedId(scriptId);
                        if (parsedItem.Commands.Command &&
                            ((Array.isArray(parsedItem.Commands.Command) && parsedItem.Commands.Command.length > 0)
                            || (!Array.isArray(parsedItem.Commands.Command) && typeof parsedItem.Commands.Command === 'object'))) {
                            obj.Scripts.Script.push(parsedItem);
                        }
                        else {
                            // Remove empty event
                            delete obj.Events[eventId];
                        }
                    }
                    return;
                }
                commands = listService.getBehaviorInstanceObjects(scriptId);
               // console.log(`$$$$ commands`, commands);


                // Lazy-init containers
                if (obj._type !== 'workflowconnector') {
                    obj.Events = obj.Events || {};
                    obj.Scripts = obj.Scripts || {Script: []};
                    obj.Events[eventId] = listService.getCleanedId(scriptId);
                }

                script = {};
                script['_id'] = listService.getCleanedId(scriptId);
                script['_type'] = 'script';
                script['_name'] = model.get('text');
                script['_showProcessing'] = model.get('showProcessing');

                script.Properties = {};
                script.Properties['_width'] = model.get('width');
                script.Properties['_height'] = model.get('height');

                processedConnectors = {};

                // enum commands, emitting each to script
                script.Commands = {Command: []};

                let command;
                commands.forEach((vc, kc) => {
                    command = {};

                    command['_id'] = listService.getCleanedId(vc.model.get('id'));
                    command['_type'] = vc.model.get('type');

                    command.Properties = {};
                    _.forEach(vc.model.attributes, (va, ka) => {
                        if (!commandPropExclusions.has(ka)) {
                            command.Properties[util.prefixLeadingUnderscore(xlateProp(ka))] = va;
                        }
                    });
                   
                    // Temporary: If no width or height, default them (most behaviors don't have them)
                    command.Properties['_width'] = command.Properties['_width'] ? Math.round(command.Properties['_width']) :  '126';
                    command.Properties['_height'] = command.Properties['_height'] ? Math.round(command.Properties['_height']) : '40';

                    if(vc.model.get("factoryKey") === "command_connect_search"){
                        let message = vc.model.get("message");
                        message = message.replace(/&#10;/g, '<br>').replace(/\n/ig, '<br>');
                        message = message.replace(/'/g, '&#39;');
                        command.Properties['_message'] = message;
                    }

                    // removed for now                    originToTopLeft( command.Properties );

                    // handle Notifications (command_notify)
                    if (vc.model.attributes.notifications) {
                        command.Notifications = {};
                        command.Notifications.Notification = [];

                        let Notification, Condition;
                         _.forEach(vc.model.attributes.notifications, (notification) => {
                            if (notification.notificationId && notification.notificationId !== '') {
                                Notification = {};
                                Notification['_id'] = notification.notificationId;
                                Notification['_type'] = 'notificationDefinition';
                                Notification.Properties = {};
                                Condition = {};
                                Notification.Condition = [];

                                for (var p in notification) {
                                    if (notification.hasOwnProperty(p) && typeof notification[p] !== 'undefined' && p !== 'notificationId') {
                                        if (notificationsPropInclusions.includes(p)){
                                            let val = notification[p];
                                            const key = `_${p}`;

                                            if (p === 'emailServerId' && val && val.toLowerCase() === 'default'){ //PF-5562 - Some behaviors are not triggered when an instance is submitted
                                                val = '';
                                            }

                                            // Must Generate the Expression that will be included later in the structure, but only return the ID of it here.
                                            if (p === 'cancelCondition' && val) {
                                                //PF-5088 the problem is in the xml the condition is missing the tag <Expression> that contains the arguments
                                                Condition.Expression = formulaService.convertExpression(val);
                                                Notification.Condition.push(Condition);
                                            }

                                            if (p === 'activationDateExpression') {
                                                if (notification.activationType ==='5' && val){
                                                    Notification.ActivationDateExpression = {};
                                                    Notification.ActivationDateExpression.Expression  = formulaService.convertExpression(val);
                                                    val = Notification.ActivationDateExpression.Expression._id;
                                                } else {
                                                    val = '';
                                                }
                                            }
                                            if (p === 'cancelCondition' && val && Condition && Condition.Expression) {
                                                Notification.Properties[key] = Condition.Expression._id;
                                            }else{
                                                Notification.Properties[key] = val;
                                            }
                                        }
                                    }
                                }

                                command.Notifications.Notification.push(Notification);
                            }
                        });
                    }                 
                  
                    if (vc.model.attributes.Parameters) {
                        command.Parameters = {};
                        command.Parameters.Parameter = [];
                        let formulaParameters = undefined;
                        if(vc.model.attributes.formulaParameter){
                            formulaParameters = vc.model.attributes.formulaParameter;
                        }
                        let Parameter, conditionType;
                        _.forEach(vc.model.attributes.Parameters.Parameter, parameter => {                            
                            Parameter = {};
                            for (var p in parameter) {
                                if (parameter.hasOwnProperty(p) && (parameter[p] !== undefined) && (p !== 'EXPR') && (p !== 'Expression')) {
                                    const val = parameter[p];
                                    if (p !== '$' || !util.isEmpty(val.trim())) {
                                        const key = `_${p}`;
                                        Parameter[key] = val;
                                    }
                                }
                            }

                            conditionType = vc.model.get("conditionType");
                            
                            //If expression is an empty object or doesn't contain arguments don't create the node Expression
                            const existExpression = parameter.Expression && typeof parameter.Expression.id !== 'undefined' && parameter.Expression.arguments && parameter.Expression.arguments.length > 0 ;

                            if(conditionType && existExpression){
                                Parameter.Expression = conditionType === "simple" ? formulaService.convertExpression(parameter.Expression) :
                                                                                        formulaService.convertExpression(formulaParameters);    
                            }
                            else if(formulaParameters){
                                Parameter.Expression = formulaService.convertExpression(formulaParameters);
                            } else if(existExpression) {
                                Parameter.Expression = formulaService.convertExpression(parameter.Expression);
                            }

                            if(!_.isEmpty(Parameter)){
                                command.Parameters.Parameter.push(Parameter);
                            }  else if (Parameter._type === 'field') {
                                // PF-3459 Set field option: ALso fixup "_special" attribute
                                Parameter._special = 'stage';
                                command.Parameters.Parameter.push(Parameter);
                            }

                        });
                        if(!command.Parameters.Parameter || command.Parameters.Parameter.length === 0){
                            delete command.Parameters;
                        }
                    }
                    
                    if (vc.model.attributes.Property) {

                        switch (vc.model.get('factoryKey')) {

                            case "command_check_obligatory":
                                command.Properties.Property = {};
                                command.Properties.Property.Item = [];

                                command.Properties.Property._id = vc.model.attributes.Property._id;

                                _.forEach(vc.model.attributes.Property.Item, (item) => {
                                    if (item._value){
                                        command.Properties.Property.Item.push(item);
                                    }else{
                                        command.Properties.Property.Item.push({_value: item});
                                    }
                                });
                                break;
                            case "command_set_selection_items":
                            case "command_copy_field_values":
                            case "command_set_state":
                                command.Properties.Property = vc.model.attributes.Property;
                                break;

                        }
                    }
                   
                    if (vc.model.attributes.Request) {
                        command.Request = {};
                        //Processing Send parameters
                        command.Request.Send = {};
                        command.Request.Send.parameter = [];
                        let formulaParameters = undefined;

                        _.forEach(vc.model.attributes.Request.Send.parameter, parameter => {
                            if(parameter){
                                if (parameter._type === 'expression'){
                                    const Parameter = $.extend(true, {}, parameter);
                                    formulaParameters = parameter.Expression;

                                    if(formulaParameters){
                                        Parameter.Expression = formulaService.convertExpression(formulaParameters);
                                    } else if(parameter.Expression  && parameter.Expression.arguments) {
                                        Parameter.Expression = formulaService.convertExpression(parameter.Expression);
                                    }

                                    if(!_.isEmpty(Parameter)){
                                        // PF-4017 2nd issue: was duplicate send expressionns - rendered Expression and EXPR
                                        if (Parameter.EXPR){
                                            delete Parameter.EXPR;
                                        }
                                        command.Request.Send.parameter.push(Parameter);
                                    }
                                }else{
                                    if (parameter.Expression){
                                        delete parameter.Expression;
                                    }
                                    if (parameter.EXPR){
                                        delete parameter.EXPR;
                                    }

                                    command.Request.Send.parameter.push(parameter);
                                }
                            }
                        });
                        if(!command.Request.Send.parameter || command.Request.Send.parameter.length === 0){
                            delete command.Request.Send.parameter;
                        }

                        //Processing Receive parameters
                        command.Request.Receive = {};
                        command.Request.Receive.parameter = [];
                        formulaParameters = undefined;
                        if(vc.model.attributes.Request.Receive.parameter){
                            formulaParameters = vc.model.attributes.Request.Receive.parameter;
                        }
                        _.forEach(vc.model.attributes.Request.Receive.parameter, parameter => {
                            if(parameter){
                                if (parameter._type === 'expression'){
                                    const Parameter = $.extend(true, {}, parameter);
                                    formulaParameters = parameter.Expression;

                                    if(formulaParameters){
                                        Parameter.Expression = formulaService.convertExpression(formulaParameters);
                                    } else if(parameter.Expression  && parameter.Expression.arguments) {
                                        Parameter.Expression = formulaService.convertExpression(parameter.Expression);
                                    }

                                    if(!_.isEmpty(Parameter)){
                                        // PF-4017 2nd issue: was duplicate receive expressionns - rendered Expression and EXPR
                                        if (Parameter.EXPR){
                                            delete Parameter.EXPR;
                                        }
                                        command.Request.Receive.parameter.push(Parameter);
                                    }
                                }else{
                                    if (parameter.Expression){
                                        delete parameter.Expression;
                                    }
                                    if (parameter.EXPR){
                                        delete parameter.EXPR;
                                    }
                                    
                                    //PF-6501 Check if the param value might be from a table
                                    if (parameter._value && parameter._value.includes('$')) {
                                        let id = parameter._value.split('$');
                                        let tableObject = listService.getObject(listService.cleanId(id[0]));

                                        if (tableObject && tableObject.model !== undefined) {
                                            if(tableObject.model.get("factoryKey") === "control_table"){
                                                let value = id[1].split("_")[1];
                                                if (value) {
                                                    //PF-6501 check if the column still exists, if it does not exists remove the value from the connection param
                                                    let column = tableObject.model.get("gridData").filter(column => column.id === listService.cleanId(value));
                                                    if (!column || !column.length) {
                                                        parameter._value = "";
                                                    }
                                                }
                                            }
                                        } else {
                                            // PF-9577 if model doesn't exist (table has been deleted) then remove the value from the connection param
                                            parameter._value = "";
                                        }
                                        
                                    }          
                                    command.Request.Receive.parameter.push(parameter);
                                }
                            }
                        });
                        if(!command.Request.Receive.parameter || command.Request.Receive.parameter.length === 0){
                            delete command.Request.Receive.parameter;
                        }
                    }

                    if (vc.model.attributes.CustomParameters) {
                        //command.CustomParameters = vc.model.attributes.CustomParameters;

                        if (vc.model.attributes.CustomParameters) {
                            command.CustomParameters = {};
                            command.CustomParameters.parameter = [];

                            let Parameter;
                            _.forEach(vc.model.attributes.CustomParameters.parameter, (parameter) => {
                                Parameter = {};

                                for (var p in parameter) {
                                    if (parameter.hasOwnProperty(p) && (parameter[p] !== undefined) && (p !== 'EXPR') && (p !== 'Expression')) {
                                        let val = parameter[p];
                                        if (p !== '$' || !util.isEmpty(val.trim()) ) {
                                            //const key = `_${p}`;
                                            Parameter[p] = val;
                                        }
                                    }
                                }

                                if (parameter.Expression) {

                                    Parameter.Expression = formulaService.convertExpression(parameter.Expression);
                                }

                                command.CustomParameters.parameter.push(Parameter);
                            });
                        }
                    }

                    const cons = listService.behaviorConnections;   
                    if (cons) {
                        // TODO Only if cons and cons for THIS script ID. Otherwise could emit empty connectors elem
                        script.Connectors = script.Connectors || {Connector: []};
                        emitConnectors(script.Connectors.Connector, cons, processedConnectors, scriptId);
                    }                  
                    script.Commands.Command.push(command);
                    //console.log(`commmand`, kc, vc);
                });

                if (obj._type === 'workflowconnector') {
                    obj.Script = script;
                } else {
                    if (script.Commands.Command.length) {
                        obj.Scripts.Script.push(script);
                    }
                    else {
                        // Remove empty event
                        delete obj.Events[eventId];
                    }
                }
                
                if (listService.mainKind !== constants.KIND_BEHAVIORS || scriptId !== listService.currentBehaviorInstanceId){ //Don't store current displayed behavior instance because it can still be modified                    
                    if (typeof script !== 'undefined'){
                        model.set('parsedItem', _.cloneDeep(script), constants.MODEL_SILENT); //Store the parsed item with an updated version of the script
                    }else{
                        model.unset('parsedItem');
                    }
                }

               // console.log('Scripts', obj);
            });
    }



    configureObjectOut(control, isMobile =  false) {
        /*
            This méthod should be verified when in Yoda elements are removed and the Wizard opened and save.
        */
      
        if (!control) { return; }
        /*************************  Prop Config For Out *****************/
        function EXPR(column) {
            var EXPR = [];
            EXPR.push({_type: 'reportingColumn'});
            if (Array.isArray(column.EXPR.EXPR)) {
                let _arguments = [];
                let index = 0;
                _.forEach(column.EXPR.EXPR, (arg) => {
                    _arguments.push(util.applyPrefix(column.EXPR.EXPR[index]));
                    index++;
                });
                EXPR[0].Argument = _arguments;
            } else {
                EXPR[0].Argument = util.applyPrefix(column.EXPR.EXPR);
            }
            return EXPR;
        }

        const self = this;
        const objOut = {};
        objOut._id = listService.getCleanedId(control.model.get('id'));
        objOut._type = inverseTypeMap.get(control.model.get('factoryKey'), 'not-set');
        if (objOut._type === 'tickboxgroup' || objOut._type === 'radiobuttongroup') {
            objOut._type = 'group';
        }
        objOut._name = control.model.get('name');

        // Tickboxgroup becomse group
        if (objOut._type === "tickboxgroup") {
            objOut._type = "group";
        }

        // RadiobuttonGroup becomes group
        if (objOut._type === "radiobuttongroup") {
            objOut._type = "group";
        }

        const props = objOut.Properties = {};

        const objectKeys = () => {
            // Populates object attributes into Property element
            Immutable.List(control.model.keys())
                .filter(k => controlPropInclusions.includes(k))
                .forEach(k => {
                    let val = control.model.get(k);
                    if (typeof val !== 'undefined') {
                        if (k === 'width' || k === 'height') {
                            if (val && val.length > 2 && val.substring(0, 1) !== '~') {
                                val = util.extractNum(val);
                            }
                        }

                        if (k === 'margins') {
                            val = parseInt(val.top) + "," + parseInt(val.right) + "," + parseInt(val.bottom) + "," + parseInt(val.left);
                        }

                        // Clean - Make sure it's an int
                        if (k === 'width' || k === 'height' || k === 'left' || k === 'top' || k === 'zIndex') {
                            val = parseInt(val);
                        }

                        if (val && k.toLowerCase().includes('color')) {
                            val = val.replace('#', '');
                        }
                        const k2 = `_${k}`;
                        props[k2] = val;
                    }
                });
        };

        const fonts = () => {

             // Handle Fonts
            // FONT, SIZE
            // FONT, SIZE, WEIGHT
            // FONT, SIZE, WEIGHT, STYLE
            props['_font'] = this.processFont(control.model, ['fontFamily', 'fontSize', 'textWeight', 'textStyle']);
            props['_buttonFont'] = this.processFont(control.model, ['buttonFontFamily', 'buttonFontSize', 'buttonTextWeight', 'buttonTextStyle']);
            props['_headerFont'] = this.processFont(control.model, ['headerFontFamily', 'headerFontSize', 'headerTextWeight', 'headerTextStyle']);
            props['_titleFont'] = this.processFont(control.model, ['titleFontFamily', 'titleFontSize', 'titleTextWeight', 'titleTextStyle']);

            let _webFont = this._getWebFontProperty(props);

            if (_webFont){
                props['_webFont'] = _webFont;
            }
        };

        const borders = () => {
             // Handle Border
            if (control.model.get('borderSize') && control.model.get('borderStyle') && control.model.get('cornerRadius')) {
                if (!control.model.get('borderSize').startsWith('~') || !control.model.get('borderStyle').startsWith('~') ||
                    !control.model.get('cornerRadius').startsWith('~') || control.model.get('factoryKey') === 'control_drop_down' ) {

                    let b = themeService.resolveThemeBorder('borderSize', control.model.get('borderSize'));
                    b = b + ',' + themeService.resolveThemeBorder('borderStyle', control.model.get('borderStyle'));
                    if (!control.model.get('cornerRadius').startsWith('~')) {
                        b = b + ',' + themeService.resolveThemeBorder('cornerRadius', control.model.get('cornerRadius'));
                    }

                    props['_border'] = b;
                } else {
                    props['_border'] = control.model.get('borderSize');
                }
            }
        };

        const colorMapping = () => {
             // Color Mapping
            self.setColorValue(props, '_textColor', control.model.get('styleColorText'));
            self.setColorValue(props, '_textDownColor', control.model.get('styleColorTextDown'));
            self.setColorValue(props, '_mouseOverTextColor', control.model.get('styleColorTextOver'));

            //self.setColorValue(props, '_backgroundColor', control.model.get('advancedBgColor'));
            self.setColorValue(props, '_bgGradientColor', control.model.get('advancedBgGradientColor'));
            self.setColorValue(props, '_mouseOverColor', control.model.get('advancedBgColorOver'));
            self.setColorValue(props, '_bgGradientOverColor', control.model.get('advancedBgGradientColorOver'));
            self.setColorValue(props, '_backgroundDownColor', control.model.get('advancedBgColorDown'));
            self.setColorValue(props, '_bgGradientDownColor', control.model.get('advancedBgGradientColorDown'));

        };

        const parameters = () => {

             // Parameters
            if (control.model.get('Parameters')) {

                objOut.Parameters = {};
                objOut.Parameters.Parameter = [];

                _.forEach(control.model.attributes.Parameters.Parameter, (parameter) => {
                    let Parameter = {};

                    for (var p in parameter) {
                        if (parameter.hasOwnProperty(p) && (parameter[p] !== undefined) && (p !== 'EXPR') && (p !== 'Expression')) {
                            let val = parameter[p];
                            if (p === '$' && util.isEmpty(val.trim())) {
                                console.log('Ignore', p, val);
                            } else {
                                const key = `_${p}`;
                                Parameter[key] = val;
                            }
                        }
                    }

                    if (parameter.Expression && parameter.Expression.id)  {
                        
                        Parameter.Expression = formulaService.convertExpression(parameter.Expression, false, true);
                        //PF-6196 These properties should not be saved; Just Parameter.Expresion
                        if(Parameter._EXPR){
                            delete Parameter._EXPR;
                        }
                        if(Parameter._Expression){
                            delete Parameter._Expression;
                        }
                    }

                    objOut.Parameters.Parameter.push(Parameter);

                });
            }

        };

        const customParameters = () => {

            // #PF-1951 Saving Custom Parameters.
            if (control.model.get("CustomParameters")) {
                objOut.CustomParameters = {};
                objOut.CustomParameters.parameter = [];

                _.forEach(control.model.attributes.CustomParameters.parameter, (parameter) => {
                    let Parameter = {};

                    for (var p in parameter) {
                        if (parameter.hasOwnProperty(p) && (parameter[p] !== undefined) && (p !== 'EXPR') && (p !== 'Expression')) {
                            let val = parameter[p];
                            if (p !== '$' || !util.isEmpty(val.trim())) {
                                //const key = `_${p}`;
                                Parameter[p] = val;
                            }
                        }
                    }

                    if (parameter.Expression) {

                        Parameter.Expression = formulaService.convertExpression(parameter.Expression);
                    }

                    objOut.CustomParameters.parameter.push(Parameter);
                });
            }
        };

        const columns = () => {
            // Columns
            if (control.model.get('factoryKey') === 'control_filter_input'
                || control.model.get('factoryKey') === 'control_filter_selector'
                || control.model.get('factoryKey') === 'control_crosstab') {
                objOut.Columns = {};
                objOut.Columns.Column = [];

                const columns = control.model.get('Columns');
                if (columns) {
                    if (Array.isArray(columns.Column)) {
                        if (util.isChart(control.model.get('factoryKey'))) {
                            _.forEach(columns.Column, (column) => {
                                if (column.EXPR) {
                                    objOut.Columns.Column.push({
                                        _id: column.id,
                                        Properties: util.applyPrefix(column.Properties),
                                        Expression: formulaService.convertExpression(column.EXPR)
                                    });
                                } else {
                                    objOut.Columns.Column.push({ _id: column.id, Properties: util.applyPrefix(column.Properties) });
                                }
                            });
                        } else {
                            _.forEach(columns.Column, (column) => {
                                objOut.Columns.Column.push({ _id: column.id, Properties: util.applyPrefix(column.Properties) });
                            });
                        }
                    } else {
                        objOut.Columns.Column.push({
                            _id: columns.Column.id,
                            Properties: util.applyPrefix(columns.Column.Properties)
                        });
                    }
                }
            }
        };

        const columnsCharts = () => {

            // Columns charts
            if (util.isChart(control.model.get('factoryKey'))) {
                const columns = control.model.get('Columns');
                if (columns && columns.Column && columns.Column.length > 0) { //PF-6427 - PF-6397  Report's page is shown outside the designer. Columns tag in XML should not be rendered at all when there are no Columns
                    objOut.Columns = {};
                    objOut.Columns.Column = [];
                    if (Array.isArray(columns.Column)) {
                        _.forEach(columns.Column, (column) => {
                            if (column.EXPR) {
                                objOut.Columns.Column.push({
                                    _id: column.id,
                                    Properties: util.applyPrefix(column.Properties),
                                    Expression: formulaService.convertExpression(column.EXPR, true)
                                });
                            } else {
                                objOut.Columns.Column.push({ _id: column.id, Properties: util.applyPrefix(column.Properties) });
                            }
                        });
                    } else {
                        if (column.EXPR) {
                            objOut.Columns.Column.push({
                                _id: columns.Column.id,
                                Properties: util.applyPrefix(columns.Column.Properties), Expression: EXPR(column)
                            });
                        } else {
                            objOut.Columns.Column.push({
                                _id: columns.Column.id,
                                Properties: util.applyPrefix(columns.Column.Properties)
                            });
                        }
                    }
                }
            }

        };

        const tables = () => {

            if (control.model.get('factoryKey') === 'control_table') {
                const Columns = {};
                Columns.Column = [];

                // const excludeTableProps = Immutable.Set(['id', 'type', 'name']);
                const includeTableProps = Immutable.Set(['align', 'header', 'index', 'borderColor', 'selected',
                    'backgroundColor', 'width', 'obligatoryMessage', 'bgGradientColor', 'text', 'textDownColor',
                    'backgroundDownColor', 'border', 'mouseOverTextColor', 'textColor', 'font', 'mouseOverColor',
                    'bgGradientOverColor', 'cornerRadius', 'bgGradientDownColor', 'showNow', 'showEmpty',
                    'is24HourClock', 'hasSeconds', 'footerfun',
                    'mouseOverTextColor', 'backgroundDownColor', 'textColor', 'formId', 'formName', 'text', 'border',
                    'bgGradientColor', 'backgroundColor', 'borderColor', 'textDownColor', 'bgGradientOverColor',
                    'formGUID', 'cornerRadius', 'bgGradientDownColor', 'newWindow', 'linkId', 'childInstanceGUID',
                    'mouseOverColor', 'showError', 'customFiltypes', 'buttonPositionLeft', 'buttonTextColor',
                    'buttonBackgroundColor', 'buttonFont',
                    'buttonLabelDetach', 'maxSize', 'buttonLabelAttach', 'filetypes',
                    'format', 'specific', 'minYear', 'maxYear', 'defaultValue', 'buttonTextColor', 'customFiltypes',
                    'filetypes', 'buttonBackgroundGradientColor', 'buttonBackgroundColor', 'buttonLabelDetach',
                    'maxSize', 'buttonPositionLeft', 'buttonLabelAttach', 'buttonFont', 'maxChars', 'text', 'decimalLength',
                    'decimalSeparator', 'thousandsSeparator', 'min', 'max', 'showLeadingZero', 'allowNegative', 'symbol', 'autocomplete',
                    'autocompleteEnabled', 'autocompleteActivateOn', 'autocompleteSource', 'listId'
                ]);

                const colTblCheckboxProps = Immutable.Set(['backgroundColor', 'obligatoryMessage', 'selected', 'width',
                'header', 'index', 'transparentBackground']);

                const colTblRadioButtonProps = Immutable.Set(['backgroundColor', 'obligatoryMessage', 'width',
                'header', 'index', 'transparentBackground']);

                // PF-4915
                const colTblTimeInputProps = Immutable.Set(['backgroundColor', 'border', 'font', 'borderColor',
                    'hasSeconds', 'header', 'index', 'is24HourClock', 'obligatoryMessage', 'showEmpty', 'showNow',
                    'specific', 'textColor', 'width'
                ]);

                // Build Columns based on GridData in model
                let gridData = control.model.get('gridData');
                if (gridData) {
                    // PK-4860: Enforce removal of any undefined (deleted) rows -- (row deletion in prop view didn't always remove them)
                    gridData = (() => {
                        const gd2 = [];
                        gridData.map(v => {
                            if (v) {
                                gd2.push(v);
                            }
                        });
                        return gd2;
                    })();
                    control.model.set('gridData', gridData, { silent: true });


                    for (let i = 0; i < gridData.length; i++) {
                        // PF-4860 regen index required by by player print
                        gridData[i].set('index', i, { silent: true });

                        // build Column and its Properties
                        const newColumn = {
                            '_id': listService.getCleanedId(gridData[i].id),
                            '_type': gridData[i].get('type'),
                            '_name': gridData[i].get('name'),
                            'Properties': {}
                        };


                        // Need a tech debt ticket to impose per-col attribute sets like we're doing with PF-4915 tbl_timeInput here
                        let inclSet;
                        switch (newColumn._type){
                            case 'tbl_timeInput':
                                inclSet = colTblTimeInputProps
                                break;
                            case 'tbl_tickbox':
                                inclSet = colTblCheckboxProps;
                                break;
                            case 'tbl_radioButton':
                                inclSet = colTblRadioButtonProps;
                                break;
                            default:
                                inclSet = includeTableProps;
                                break;
                        }

                        _.forEach(gridData[i].attributes, (va, ka) => {

                            if (inclSet.has(ka)) {
                                let val = va;
                                if (val && ka.toLowerCase().includes('color')) {
                                    val = val.replace('#', '');
                                }

                                if(ka.toLowerCase() === "width"){
                                    val = gridData[i].attributes.realWidth || val;
                                }

                                // No align for Table Button
                                if (newColumn._type === 'tbl_button' && ka === 'align') {
                                    // Don't add this
                                } else {
                                    newColumn.Properties[util.prefixLeadingUnderscore(ka)] = val;
                                }
                                
                            }
                        });

                        newColumn.Properties['_font'] = this.processFont(gridData[i], ['fontFamily', 'fontSize', 'textWeight', 'textStyle']);
                        newColumn.Properties['_buttonFont'] = this.processFont(gridData[i], ['buttonFontFamily', 'buttonFontSize', 'buttonTextWeight', 'buttonTextStyle']);

                        let _webFont = this._getWebFontProperty(newColumn.Properties);

                        if (_webFont){
                            newColumn.Properties['_webFont'] = _webFont;
                        }

                        // Handle Border
                        if (gridData[i].get('borderSize') && gridData[i].get('borderStyle') && gridData[i].get('cornerRadius')) {
                            if (!newColumn.Properties['_border']) {
                                newColumn.Properties._border = '';
                            }
                            if (!gridData[i].get('borderSize').startsWith('~') || !gridData[i].get('borderStyle').startsWith('~') ||
                                !gridData[i].get('cornerRadius').startsWith('~') || gridData[i].get('factoryKey') === 'control_drop_down') {

                                let b = themeService.resolveThemeBorder('borderSize', gridData[i].get('borderSize'));
                                b = b + ',' + themeService.resolveThemeBorder('borderStyle', gridData[i].get('borderStyle'));
                                if (!gridData[i].get('cornerRadius').startsWith('~')) {
                                    b = b + ',' + themeService.resolveThemeBorder('cornerRadius', gridData[i].get('cornerRadius'));
                                }

                                newColumn.Properties['_border'] = b;
                            } else {
                                newColumn.Properties['_border'] = gridData[i].get('borderSize');
                            }
                        }

                        if (gridData[i].attributes.CustomParameters) {
                            newColumn.CustomParameters = {};
                            newColumn.CustomParameters.parameter = [];

                            _.forEach(gridData[i].attributes.CustomParameters.parameter, (parameter) => {
                                let Parameter = {};

                                for (var p in parameter) {
                                    if (parameter.hasOwnProperty(p) && (parameter[p] !== undefined) && (p !== 'EXPR') && (p !== 'Expression')) {
                                        let val = parameter[p];
                                        if (p !== '$' || !util.isEmpty(val.trim())) {
                                            //const key = `_${p}`;
                                            Parameter[p] = val;
                                        }
                                    }
                                }

                                if (parameter.Expression) {

                                    Parameter.Expression = formulaService.convertExpression(parameter.Expression);
                                }

                                newColumn.CustomParameters.parameter.push(Parameter);
                            });
                        }


                        // PF-4860 Flash client had no empty CustomParameters, so we don't
                        if (newColumn._type !== 'tbl_childFormButton'
                            && newColumn.CustomParameters
                            && newColumn.CustomParameters.parameter
                            && Array.isArray(newColumn.CustomParameters.parameter)
                            && newColumn.CustomParameters.parameter.length < 1) {

                            delete newColumn.CustomParameters;
                        }

                        // Adding State Handling for Table Columns
                        if (gridData[i].get('state')) {
                            newColumn.States = {};
                            newColumn.States.State = [];

                            const stateMap = gridData[i].get('state');
                            stateMap.forEach(v => {
                                if(v.value){ //PF-10744
                                    const
                                        stageid = v.stageId || ID_ALL,
                                        roleid = v.roleId || ID_ALL;

                                    const state = {
                                        _id: `${stageid}_${roleid}`,

                                        _value: v.value
                                    };

                                    newColumn.States.State.push(state);
                                }
                            });

                            // AS client doesn't save empty State XML elements, so we don't, either.
                            if (!newColumn.States.State.length) {
                                delete newColumn.States;
                            }
                        }

                        if (gridData[i].attributes.Parameters) {

                            newColumn.Parameters = {};
                            newColumn.Parameters.Parameter = [];

                            _.forEach(gridData[i].attributes.Parameters.Parameter, (parameter) => {
                                let Parameter = {};

                                for (var p in parameter) {
                                    if (parameter.hasOwnProperty(p) && (parameter[p] !== undefined) && (p !== 'Expression1')) {
                                        let val = parameter[p];
                                        if (p !== '$' || !util.isEmpty(val.trim())) {
                                            const key = `_${p}`;
                                            Parameter[key] = val;
                                        }
                                    }
                                }

                                if (parameter.Expression) {
                                    Parameter.Expression = formulaService.convertExpression(parameter.Expression);
                                }

                                newColumn.Parameters.Parameter.push(Parameter);

                            });
                        }

                        if (gridData[i].attributes.Property) {
                            newColumn.Properties.Property = gridData[i].attributes.Property;
                        }

                        if (!newColumn.Properties._customFormat) {
                            newColumn.Properties._customFormat = '';
                        }

                        if (!newColumn.Properties._maxChars) {
                            newColumn.Properties._maxChars = '99';
                        }

                        if (gridData[i].attributes.mandatories) {
                            newColumn.Obligatories = {};
                            newColumn.Obligatories.Obligatory = [];

                            const mandatory = gridData[i].attributes.mandatories;

                            if (mandatory.has('all_all')) {
                                let value = mandatory.get('all_all');
                                if (!util.isTrue(value.required)) {
                                    mandatory.delete('all_all');
                                }
                            }

                            mandatory.forEach(v => {
                                newColumn.Obligatories.Obligatory.push({
                                    _id: v.stageId + '_' + v.roleId,
                                    _value: util.isTrue(v.required)
                                });
                            });
                        }

                        // PF-4915 time input remove attrs that leak into the control via common processing after building props
                        if (newColumn._type === 'tbl_timeInput') {
                            delete newColumn.Properties['_buttonFont'];
                            delete newColumn.Properties['_customFormat'];
                            delete newColumn.Properties['_maxChars'];
                        }

                        //PF-8544 - PF-8543 Table numeric column - Max value causes losing data after submit
                        if (newColumn._type === 'tbl_numericInput') {
                            newColumn.Properties._min = util.roundCeilAbsolute(newColumn.Properties._min);
                            newColumn.Properties._max = util.roundCeilAbsolute(newColumn.Properties._max);
                        }
                        Columns.Column.push(newColumn);
                    }

                }

                objOut.Columns = Columns;
            }
        };

        const lists = () => {
            if (control.model.get('factoryKey') === 'control_list' || control.model.get('factoryKey') === 'control_drop_down') {
                objOut.Properties.Property = [];
    
                let gridData = control.model.get('gridData');
                let values = [];
                let captions = [];
                // PF-1289 "selectedIndex" was really the selected VALUE.  It caused a bug via misunderstood meaning. @lem
                let selectedValue;
                let
                    selectedRowIndex = -1,
                    runningRowIndex = 0;
    
                _.forEach(gridData, pair => {
                    values.push({'_value': pair.value});
                    captions.push({'_value': pair.caption});
                    if (pair.selected === 'selected'){
                        selectedValue = pair.value;
                        selectedRowIndex = runningRowIndex;
                    }
                    runningRowIndex++;
                });
    
                objOut.Properties.Property.push({'_id':'values', 'Item':values});
                objOut.Properties.Property.push({'_id':'captions', 'Item':captions});
    
                // PF-1289
                if (selectedValue) {
                    control.model.set('selectedIndex', selectedRowIndex, {silent: true});
                }
            }
        };

        const ranking = () => {
            if (control.model.get('factoryKey') === 'control_ranking') {
                objOut.Properties.Property = [];
    
                let gridData = control.model.get('gridData');
                let ranks = [];
                let captions = [];
                // PF-1289 "selectedIndex" was really the selected VALUE.  It caused a bug via misunderstood meaning. @lem
                let selectedValue;
                let
                    selectedRowIndex = -1,
                    runningRowIndex = 0;
    
                _.forEach(gridData, pair => {
                    ranks.push({'_value': pair.rank});
                    captions.push({'_value': pair.item});
                    runningRowIndex++;
                });
    
                objOut.Properties.Property.push({'_id':'ranks', 'Item':ranks});
                objOut.Properties.Property.push({'_id':'captions', 'Item':captions});
            }
        };

        const mandatories = () => {

            if (control.model.get('mandatories')){
                objOut.Obligatories = {};
                objOut.Obligatories.Obligatory = [];
    
    
                const mandatory = control.model.get('mandatories');
    
                mandatory.forEach((v, k) => {
                    objOut.Obligatories.Obligatory.push({
                        _id: k,
                        _value: util.isTrue(v.required)
                    });
                });
    
                if (objOut.Obligatories.Obligatory.length === 0) {
                    delete objOut.Obligatories;
                }
            }
        };

        const eventsAndScripts = () => {
            // Injects events and scripts
            if (!isMobile) {

                 this.behaviorsSaveHelper(objOut, control);
              
                // If control is a table, maybe its columns have events and scripts
                if (control.model.get('factoryKey') === 'control_table' && control.getColumns) {
                    // objOut is table. Drill-down to the the column
                    _.forEach(control.getColumns(), (c, k) => {
                        const col = control.getColumn(c.id);
                        this.behaviorsSaveHelper(objOut.Columns.Column[k], col);
                    });
                }
            }
        };

        objectKeys();
        fonts();
        borders();
        colorMapping();
        parameters();
        customParameters();


        if (control.model.get('Property')) {
            props.Property = control.model.get('Property');
        }
        
        //Render States
        this._renderObjectStates(control, objOut);


        columns();
        columnsCharts();
        tables();

        lists();
        ranking();

        mandatories();
       

        eventsAndScripts();          

        return objOut;

        /******************************/
    }

    objectsHelperGroups(parent, refPageId) {
        const objs = parent.Objects = {Object: []};

        listService.objectList
            .filter(control => control.pageId && control.pageId === refPageId && (control._groupId === listService.cleanId(parent._id)))
            .sortBy((control) => -control.model.get('tabIndex'))
            .reverse()
            .forEach(control => {
                const objOut = this.configureObjectOut(control);

                if (constants.GROUP_KEYS.contains(control.model.get('factoryKey'))) {
                    // loop through childList Models , retrieve the views and process
                    this.objectsHelperGroups(objOut, refPageId);
                }

                objs.Object.push(objOut);
            });
    }

    mobileObjectsHelperGroups(parent, refPageId) {
        const objs = parent.Objects = {Object: []};
        mobileListService.getMobileControls()
            .filter(control => control._groupId === parent._id)
            .sortBy((control) => control.model.get('tabIndex'))
            .forEach(control => {
                const objOut = this.configureObjectOut(control);
                const mobileObj = listService.getMobileObject(control.id);
                objOut.Properties._isNew = mobileObj.isNew;
                if (constants.GROUP_KEYS.contains(control.model.get('factoryKey'))) {
                    // loop through childList Models , retrieve the views and process
                    this.mobileObjectsHelperGroups(objOut, refPageId);
                }

                objs.Object.push(objOut);
            });

    }

    objectsHelper(parent, refPageId, pageView) {

        const objs = parent.Object = [];

        // PF-787: reverse() forces following loop to always see a group before its children.
        // This enables a child pass to push itself onto the group's Objects.Object list.
        // Without reverse, the group is not yet known at the time of the child's processing here.
        // Side-effect: repeated saves alternately reverse the order of the children in Objects.Object list.
        // The group remains first, which is good.
        // If reversing kin-order ia problem, we'll need to take a first pass to locate all the groups in the
        // input object so that child processing can find each. -Lou Mauget, 2016-9-12

        //loop through objects on page, excluding any that belong to Groups
        let objOut;
        listService.objectList
            .filter(control => control.pageId && control.pageId === refPageId && (!control._groupId))
            .sortBy((control) => -control.model.get('tabIndex'))
            .reverse()
            .forEach(control => {

                objOut = this.configureObjectOut(control);

                if (constants.GROUP_KEYS.contains(control.model.get('factoryKey'))) {
                    // loop through childList Models , retrieve the views and process
                    this.objectsHelperGroups(objOut, refPageId);
                }

                objs.push(objOut);

            });
    }

    _renderObjectStates(controlView, controlObj){
        if (controlView.model.get('state')) {
            controlObj.States = {};
            controlObj.States.State = [];

            const stateMap = settingsUtil.cleanStates(controlView.model.get('state'));
            stateMap.forEach(v => {
                if (v.value){ //PF-10744
                    const
                        stageid = v.stageId || ID_ALL,
                        roleid = v.roleId || ID_ALL;

                    const state = {
                        _id: `${stageid}_${roleid}`,

                        _value: v.value
                    };

                    controlObj.States.State.push(state);
                }
            });

            // As client doesn't save empty State XML elements, so we don't, either.
            if (!controlObj.States.State.length) {
                delete controlObj.States;
            }
        }
    }

    //We check which the first occurence of the font properties that have actually a value so we can check if it is a web font and process it
    _getWebFontProperty(props){        
        let _webFont;
        ['_font', '_buttonFont', '_headerFont', '_titleFont'].every(_font => {
            let _fontProp = props[_font];
            let continueLoop = true;
            if (_fontProp){
                if (_fontProp.startsWith && _fontProp.startsWith('~')){
                    _webFont = themeService.resolveThemeFont('fontFamily', _fontProp);
                }else if (_fontProp.split){
                    _webFont = _fontProp.split(",")[0];
                }

                continueLoop = false;
            }

            return continueLoop;
        });
        
        if (_webFont){
            _webFont = this.processWebFont(_webFont);
        }

        return _webFont;
    }



}
const saveHelperService = new SaveHelperService();
export default saveHelperService;